import { Helmet } from 'react-helmet-async'

export const SITE = 'https://www.kosmc.ai'
const DEFAULT_IMAGE = `${SITE}/logo512.png`

interface SeoProps {
  title: string
  description: string
  /** Path of the page on www.kosmc.ai, e.g. '/autoDM'. Used for canonical + og:url. */
  path: string
  image?: string
  noindex?: boolean
}

/** Title, description, canonical and social tags for one page. */
export default function Seo ({ title, description, path, image = DEFAULT_IMAGE, noindex = false }: SeoProps): JSX.Element {
  const url = SITE + path
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex,follow' : 'index,follow'} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Kosmc AI" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

/** Page-level schema.org data; page text/meta comes from src/seo/pages.json via RouteSeo. */
export function JsonLd ({ data }: { data: object | object[] }): JSX.Element {
  const schemas = Array.isArray(data) ? data : [data]
  return (
    <Helmet>
      {schemas.map((s, i) => <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>)}
    </Helmet>
  )
}
